import {
  Link,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { useEffect, useState } from "react";
import { YellowButton } from "../../../components/UI/Button/button";
import { AuthInputPassword } from "../../../components/AuthInput/input";
import {
  checkLowerCase,
  checkPasswordNum,
  checkSpecialChar,
  checkUpperCase,
} from "../../../utils/functions";
import { talentUpdatePass } from "../../../services/talentCalls";
import { errorHandler, toastSuccess } from "../../../utils";
import Loop from "../../../assets/loader/loop.svg";
import { clientUpdatePass } from "../../../services/clientCalls";
const Login = () => {
  const { token } = useParams();
  const [load, setLoad] = useState(false);
  const [role, setRole] = useState("talent");
  const [param] = useSearchParams();
  const navigate = useNavigate();

  const [data, setData] = useState({
    newPassword: "",
    confirmPassword: "",
    resetLink: token,
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoad(true);
      if (param.get("status") === "talent") {
        const res = await talentUpdatePass(data);
        if (res.data.success) {
          toastSuccess("Your password reset successfully");
          setLoad(false);
          navigate("/login");
        }
      } else {
        const res = await clientUpdatePass(data);
        if (res.data.success) {
          toastSuccess("Your password reset successfully");
          setLoad(false);
          navigate("/login");
        }
      }
    } catch (error) {
      setLoad(false);
      error.response?.data
        ? errorHandler(error.response.data.errors, "Error")
        : errorHandler(
            "Network error: Please check your internet connection and try again.",
            "Error"
          );
    }
  };

  return (
    <>
      <div style={{ padding: "1rem" }}>
        <h2>Update Password</h2>
        <form>
          <div>
            <AuthInputPassword
              isValid={
                checkPasswordNum(data.newPassword) &&
                checkLowerCase(data) &&
                data.newPassword?.length > 9 &&
                (checkSpecialChar(data.newPassword) ||
                  checkUpperCase(data.newPassword))
              }
              label="New Password"
              type="password"
              placeholder="Password"
              name="password"
              value={data.newPassword}
              onChange={(e) => {
                setData({
                  ...data,
                  newPassword: e.target.value,
                });
              }}
              numTest={checkPasswordNum(data.newPassword)}
              uppTest={
                checkUpperCase(data.newPassword) ||
                checkSpecialChar(data.newPassword) ||
                false
              }
              lowTest={checkLowerCase(data.newPassword)}
              text="Invalid password"
            />
          </div>
          <div>
            <AuthInputPassword
              isValid={data.newPassword === data.confirmPassword}
              label="Confirm Password"
              type="password"
              placeholder="Password"
              name="confirm-password"
              value-={data.confirmPassword}
              onChange={(e) =>
                setData((prevState) => ({
                  ...prevState,
                  confirmPassword: e.target.value,
                }))
              }
              text="Passwords do not match"
            />
          </div>
          <div className="center-flex">
            {load ? (
              <img
                src={Loop}
                alt="loader"
                style={{
                  width: 120,
                }}
              />
            ) : (
              <YellowButton
                onClick={handleSubmit}
                disabled={
                  !checkPasswordNum(data.newPassword) ||
                  !checkLowerCase(data.newPassword) ||
                  data.newPassword?.length < 10 ||
                  (!checkUpperCase(data.newPassword) &&
                    !checkSpecialChar(data.newPassword)) ||
                  data.newPassword !== data.confirmPassword
                }
              >
                Reset Password
              </YellowButton>
            )}
          </div>
        </form>
      </div>
      <div path="externals">
        <p>By proceeding you have agreed to our</p>
        <Link to="/terms-of-service">Terms of Use</Link> {" & "}
        <Link to="/privacy-policy">Privacy Policy </Link>
      </div>
    </>
  );
};

export default Login;
